import { FormattedMessage } from 'react-intl';
import React from 'react';
import Label from '../Label';

export const missingValueLabel = (
  <Label role="tooltip" tabIndex={-1} basic color="red" pointing>
    <FormattedMessage id="change-password.error.missingValue" defaultMessage="Please enter a value" />
  </Label>
);

export const missingPasswordLabel = (
  <Label role="tooltip" basic color="red" pointing>
    <FormattedMessage id="change-password.error.missingCurrentPassword" defaultMessage="Please enter your current password" />
  </Label>
);

export const missingNewPasswordLabel = (
  <Label role="tooltip" basic color="red" pointing data-cy="account-info-missing-new-pass-tooltip">
    <FormattedMessage id="change-password.error.missingNewPassword" defaultMessage="Please enter a new password" />
  </Label>
);

export const missingConfirmPasswordLabel = (
  <Label role="tooltip" basic color="red" pointing data-cy="account-info-missing-confirm-pass-tooltip">
    <FormattedMessage id="change-password.error.missingConfirmPassword" defaultMessage="Please enter a confirmation password" />
  </Label>
);

export const passwordMismatchLabel = (
  <Label role="tooltip" basic color="red" pointing data-cy="account-info-pass-mismatch-tooltip">
    <FormattedMessage
      id="change-password.error.passwordMismatch"
      defaultMessage="The new password must match the confirmation password"
    />
  </Label>
);

export const passwordNotSecureLabel = (
  <Label role="tooltip" basic color="red" pointing data-cy="account-info-pass-not-secure-tooltip">
    <FormattedMessage
      id="change-password.error.passwordNotSecure"
      defaultMessage="The new password failed to satisfy security requirements"
    />
  </Label>
);
